import { render, staticRenderFns } from "./PanelMain.vue?vue&type=template&id=f54bc7e2&scoped=true&"
import script from "./PanelMain.vue?vue&type=script&lang=js&"
export * from "./PanelMain.vue?vue&type=script&lang=js&"
import style0 from "./PanelMain.vue?vue&type=style&index=0&id=f54bc7e2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54bc7e2",
  null
  
)

export default component.exports